import cx from 'classnames';
import { isEmpty } from 'lodash';
import React, { FC } from 'react';

import useThemeBlock from '@/hooks/useThemeBlock';
import { ButtonProps } from '@/helpers/Button/typings';
import { Link } from '@/helpers/Link/render';

import block from './block.json';
import { getStyles } from './styles.css';

export const ButtonFilter: FC<ButtonProps> & BlockConfigs = ({
	title = '',
	href = '',
	isActive = false,
	theme = {},
	...props
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx(
		'supt-button',
		'supt-buttonFilter',
		isActive ? 'supt-isActive' : false,
		getStyles(blockTheme)
	);

	return isEmpty(title) ? null : (
		<Link
			href={href}
			className={rootClass}
			data-no-scrollreset
			data-block={block.slug}
			{...htmlProps}
			{...props}
		>
			<span className="supt-button__inner">
				<span>{title}</span>
			</span>
		</Link>
	);
};

ButtonFilter.slug = block.slug;
ButtonFilter.title = block.title;
